import React, { Fragment } from 'react'

import { Box, Button, Typography } from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'

import { saveAs } from 'file-saver'
import { AlertDialog } from 'components'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

const SendToSegcoopDialog = ({
  open,
  handleOpen,
  refresh,
  setLoading,
  governanceProjectId,
  segcoopQueue,
}) => {
  const segcoopQueueStatus = segcoopQueue?.status
  const severity =
    constants.governanceProject.SEGCOOP_STATUS_SEVERITY[segcoopQueueStatus]
  const segcoopButtonColor =
    constants.governanceProject.SEGCOOP_BUTTON_STATUS_COLORS[segcoopQueueStatus]
  const hasReport = !!segcoopQueue?.reportFile?.url

  const snackbar = useSnackbar()
  const handleSubmit = async () => {
    try {
      setLoading(true)

      await service.dponet.governanceProject.sendToSegcoop({
        governanceProjectId: governanceProjectId,
      })

      snackbar.open({
        message:
          'O projeto foi adicionado à fila para ser enviado para o Segcoop. Você receberá um relatório ao fim do processo.',
        variant: 'success',
      })
      refresh()
      handleOpen()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleDownloadReport = async () => {
    setLoading(true)

    try {
      const url = segcoopQueue?.reportFile?.url
      const name = segcoopQueue?.reportFile?.name || 'relatorio_segcoop.pdf'
      const response = await fetch(url)
      const blob = await response.blob()

      saveAs(new Blob([blob], { type: 'pdf' }), name)
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: 'Ocorreu um erro ao baixar o relatório',
      })
    } finally {
      setLoading(false)
    }
  }

  const dialogText =
    constants.governanceProject.SEGCOOP_DIALOG_TEXT[segcoopQueueStatus]
  const bodyColor =
    constants.governanceProject.SEGCOOP_BODY_STATUS_COLORS[segcoopQueueStatus]

  return (
    <AlertDialog
      open={open}
      onClose={handleOpen}
      variant="standard"
      severity={severity ?? 'warning'}
      title={dialogText?.title ?? 'Atenção'}
      maxWidth="sm"
      fullWidth
      content={
        <Box color={bodyColor ?? '#643800'}>
          {!!segcoopQueue ? (
            <Typography variant="h6" align="center" gutterBottom>
              {dialogText?.description}
            </Typography>
          ) : (
            <>
              <Typography variant="h5" align="center" gutterBottom>
                Você tem certeza de que deseja realizar esta ação? É importante
                revisar todas as suas evidências antes de continuar.
              </Typography>
              <Typography variant="body1" align="center">
                A operação pode durar algumas horas para ser concluída. As
                evidências serão enviadas para o projeto PNGPPD - Ciclo 2026 do
                Segcoop.
              </Typography>
            </>
          )}
        </Box>
      }
      dialogActions={
        <Fragment>
          <Button variant="outlined" color="primary" onClick={handleOpen}>
            Cancelar
          </Button>
          {!segcoopQueue && (
            <Button
              variant="contained"
              style={{
                backgroundColor: segcoopButtonColor ?? '#F69617',
                color: '#fff',
              }}
              onClick={handleSubmit}
            >
              Enviar para o Segcoop
            </Button>
          )}
          {hasReport && (
            <Button
              variant="contained"
              style={{
                backgroundColor: segcoopButtonColor ?? '#F69617',
                color: '#fff',
              }}
              onClick={handleDownloadReport}
            >
              Baixar relatório
            </Button>
          )}
        </Fragment>
      }
    />
  )
}

export default SendToSegcoopDialog
